<template>
    <div :class="[isCenter ? 'layout-center-set' : 'layout-set']" :style="layoutSty">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "index",
        props: {
            layoutSty: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            isCenter: {
                type: Boolean,
                default: false
            }
        },
    }
</script>

<style lang="less" scoped>
    .layout-set {
        margin-top: 1px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        /*display: 'flex', justifyContent: 'center'*/
    }
    .layout-center-set {
        margin-top: 1px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
</style>



// WEBPACK FOOTER //
// index.vue?7deae105